import { personWithBinoculars } from "swing-assets";
import { Colors } from "swing-components";

import { msg } from "~utils";

export type NonSwingCertEmptyViewProps = {
  state?: "CA" | "NJ";
};

export function NonSwingCertEmptyView(props: NonSwingCertEmptyViewProps) {
  const { state } = props;

  if (state === undefined) return null;

  return (
    <div
      css={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 24,
        padding: "0 16px",
      }}
    >
      <img src={personWithBinoculars} alt={msg("NON_SWING_CERT_EMPTY_VIEW_IMG_ALT_TEXT")} />
      <div css={{ textAlign: "center" }}>
        <span css={{ fontWeight: 600 }}>{msg("NON_SWING_CERT_EMPTY_VIEW_HEADER", { state })}</span>
        <p css={{ margin: 0, marginTop: 8 }}>
          {msg("NON_SWING_CERT_EMPTY_VIEW_SUB_HEADER", { state })}
        </p>
      </div>
      <a
        href={`https://start.swingeducation.com/swingcert-${state.toLowerCase()}-register`}
        target="_blank"
        rel="noreferrer"
        style={{
          padding: "8px 16px",
          color: Colors.white200,
          textDecoration: "none",
          fontWeight: 600,
          textAlign: "center",
          borderRadius: 30,
          background: Colors.blue500,
          boxShadow: "0px 2px 4px 0px rgba(40, 60, 93, 0.16)",
        }}
      >
        {msg("NON_SWING_CERT_CTA", { multiplier: state === "CA" ? 2 : 3 })}
      </a>
    </div>
  );
}
